import Modal from "react-modal";
import { X } from "lucide-react";

const styleModal = {
    content: {
        position: 'static',
        zIndex: '1000',
        borderRadius : '0.5rem',
        border : '2px solid #fff',
        borderStyle: 'double',
        backgroundColor: '#221D23',
        width: 'auto',
        maxWidth: '85vw',
        height: 'auto',
        maxHeight: '90vh',
        // display //
        display: 'flex',
        flexDirection: 'column', 
        gap: '2rem',
    },
    overlay: {
        zIndex: '1000',
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        // display //
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
};


const Popup = ({
    bodyOpenClassName = "",
    isOpen = null,
    closeModal = null,
    // openModal = null,
    children = <></>,
    popupTitle = "",
}) => {

  return (
    <Modal style={styleModal} bodyOpenClassName={bodyOpenClassName} isOpen={isOpen} onRequestClose={closeModal} >
        <div className={`sign_modalHeaderDiv`}>
            <h2 className='sign_modalMainTitle'>{popupTitle}</h2>
            <button onClick={closeModal} className='sign_modalCloseButton'>
                <X className='sign_modalCloseSvg' size={32}/>
            </button>
        </div>
        {children}
    </Modal>
  );
};

export default Popup;